import { getPricingTable } from '@/shared/utils/teamSubscriptionTiers.js'

const calculateTeamInvoiceTotal = (seats, planTiers) => {
  const pricingTable = getPricingTable(planTiers)

  const lastTier = pricingTable[pricingTable.length - 1]
  if (seats >= lastTier.minSeats) return lastTier.amountInDollars * seats

  const tier = pricingTable.find(({ minSeats, maxSeats }) => {
    return seats >= minSeats && seats <= maxSeats
  })
  return tier ? tier.amountInDollars * seats : null
}

export { calculateTeamInvoiceTotal }
